import Contractor_Entity from "./contractor";
export default class Contractor extends Contractor_Entity {
  static fromList(contractorsJSON: unknown): Array<Contractor> {
    const contractors: Contractor[] = [];
    if (contractorsJSON)
      Array.isArray(contractorsJSON) &&
        contractorsJSON.forEach((contractorJSON) => {
          contractors.push(new Contractor(contractorJSON));
        });
    return contractors;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
